/**
 * Dr. Riva - Product card coupon pill active state
 * Syncs pill appearance when the sitewide coupon is applied in cart.
 */
(function () {
  'use strict';

  var PILL_SELECTOR = '[data-dr-component="cardCouponPill"]';

  function getConfiguredCouponCode() {
    return String(
      window.DR_GIFTS_CONFIG?.couponCode ||
      document.querySelector(PILL_SELECTOR)?.dataset?.couponCode ||
      ''
    )
      .trim()
      .toUpperCase();
  }

  function extractActiveDiscountCodes(cart) {
    var codes = new Set();
    var addCode = function (value) {
      var code = String(value || '').trim().toUpperCase();
      if (code) codes.add(code);
    };

    (cart?.cart_level_discount_applications || cart?.discount_applications || []).forEach(function (discount) {
      addCode(discount?.code || discount?.title);
    });

    (cart?.items || []).forEach(function (item) {
      (item?.discounts || []).forEach(function (discount) {
        addCode(discount?.code || discount?.title);
      });
      (item?.line_level_discount_allocations || []).forEach(function (alloc) {
        var app = alloc?.discount_application || alloc;
        addCode(app?.code || app?.title);
      });
      (item?.discount_allocations || []).forEach(function (alloc) {
        var app = alloc?.discount_application || alloc;
        addCode(app?.code || app?.title);
      });
    });

    return codes;
  }

  function isCouponActive(cart) {
    var configuredCode = getConfiguredCouponCode();
    if (!configuredCode || !cart) return false;
    return extractActiveDiscountCodes(cart).has(configuredCode);
  }

  function syncPills(active) {
    document.querySelectorAll(PILL_SELECTOR).forEach(function (pill) {
      pill.classList.toggle('dr-card-coupon-pill--active', active);
    });
  }

  function syncFromCart(cart) {
    syncPills(isCouponActive(cart));
  }

  function getCartStore() {
    return window.drCartStore || null;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    });
  }

  function refreshCartState() {
    return fetchCart()
      .then(syncFromCart)
      .catch(function () {
        var snapshot = getCartStore()?.getSnapshot?.();
        if (snapshot?.cart) {
          syncFromCart(snapshot.cart);
        } else {
          syncPills(false);
        }
      });
  }

  function bootstrapCartState() {
    refreshCartState();
  }

  function onCartStoreUpdated() {
    refreshCartState();
  }

  function bindCartUpdateEvents() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        refreshCartState();
      });
    }
  }

  function nodeContainsPill(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches(PILL_SELECTOR)) return true;
    return !!node.querySelector(PILL_SELECTOR);
  }

  function observeNewPills() {
    if (typeof MutationObserver === 'undefined' || !document.body) return;

    var scheduled = false;

    function scheduleRefresh() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        bootstrapCartState();
      });
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type !== 'childList' || !mutation.addedNodes.length) continue;

        for (var j = 0; j < mutation.addedNodes.length; j++) {
          if (nodeContainsPill(mutation.addedNodes[j])) {
            scheduleRefresh();
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('dr:cart-store-updated', onCartStoreUpdated);

  window.drCardCouponPill = {
    refresh: refreshCartState,
  };

  function init() {
    bindCartUpdateEvents();
    bootstrapCartState();
    observeNewPills();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
